var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{directives:[{name:"t",rawName:"v-t",value:('posete'),expression:"'posete'"}]}),_c('hr'),_c('BootstrapTable',{attrs:{"id":"poseteTable","columns":_vm.columns,"options":_vm.tableOptions,"data":_vm.visitedStores}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }